/*eslint-disable*/
import { useCallback, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import useMenu from './useMenus';
import useMenuState from './useMenuState';

const useNavdata = () => {
  const history = useNavigate();
  const { menuStates, toggleMenuState } = useMenuState();
  const { pathname } = window.location;
  const isHRPath = pathname.includes('/hr');
  let viewMode = isHRPath ? 'hr' : 'self';

  const updateIconSidebar = useCallback(e => {
    if (e?.target?.getAttribute('subitems')) {
      const ul = document.getElementById('two-column-menu');
      ul?.querySelectorAll('.nav-icon.active')?.forEach(item => {
        item.classList.remove('active');
        const id = item.getAttribute('subitems');
        document.getElementById(id)?.classList.remove('show');
      });
    }
  }, []);

  useEffect(() => {
    document.body.classList.remove('twocolumn-panel');
    if (menuStates.currentState !== 'Dashboard') {
      toggleMenuState('dashboard');
    }
  }, [history, menuStates.currentState, toggleMenuState]);

  const createClickHandler = useCallback(
    id => e => {
      e.preventDefault();
      toggleMenuState(id);
      updateIconSidebar(e);
    },
    [toggleMenuState, updateIconSidebar],
  );

  const menuItems = useMemo(
    () => [
      {
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'iconsDashboardSideMenu',
        link: '/dashboard',
        stateVariables: menuStates.dashboard,
        click: createClickHandler('dashboard'),
        visibility: 'self',
      },
      {
        id: 'approvals',
        label: 'Approvals',
        icon: 'iconsRequestSideMenu',
        link: isHRPath ? '/hr/approvals' : '/approvals',
        stateVariables: menuStates.approvals,
        click: createClickHandler('approvals'),
        visibility: 'both',
      },
      {
        id: 'timesheet',
        label: 'Timesheet',
        icon: 'iconsTimesheetSideMenu',
        link: '/timesheet',
        stateVariables: menuStates.timesheet,
        click: createClickHandler('timesheet'),
        visibility: 'self',
      },
      {
        id: 'activity',
        label: 'Activity',
        icon: 'iconsActivitySideMenu',
        link: '/activity',
        stateVariables: menuStates.activity,
        click: createClickHandler('activity'),
        visibility: 'self',
      },
      {
        id: 'leaves',
        label: 'Apply Leave',
        icon: 'iconsLeaveSideMenu',
        link: '/leave/apply',
        stateVariables: menuStates.leaves,
        click: createClickHandler('leaves'),
        visibility: 'self',
      },
      {
        id: 'compOff',
        label: 'Apply Comp Off',
        icon: 'iconsCompOffSideMenu',
        link: '/comp-off/apply',
        stateVariables: menuStates.compOff,
        click: createClickHandler('compOff'),
        visibility: 'self',
      },
      {
        id: 'applyWfh',
        label: 'Apply WFH',
        icon: 'iconsWfhSideMenu',
        link: '/wfh/apply',
        stateVariables: menuStates.wfh,
        click: createClickHandler('wfh'),
        visibility: 'self',
      },
      {
        id: 'applyOt',
        label: 'Apply Overtime',
        icon: 'iconsOverTimeSideMenu',
        link: '/overtime/apply',
        stateVariables: menuStates.applyOt,
        click: createClickHandler('applyOt'),
        visibility: 'self',
      },
      {
        id: 'loan',
        label: 'Apply Loan',
        icon: 'iconApplyLoan',
        link: '/loan/apply',
        stateVariables: menuStates.loan,
        click: createClickHandler('loan'),
        visibility: 'self',
      },
      {
        id: 'travel',
        label: 'Travel Request',
        icon: 'iconsTravelRequestSideMenu',
        link: '/travel-request',
        stateVariables: menuStates.travel,
        click: createClickHandler('travel'),
        visibility: 'self',
        keepStaticOrder: true,
      },
      {
        id: 'expenseClaim',
        label: 'Expense Claim',
        icon: 'iconsExpenseClaimsSideMenu',
        link: '/expense/claim',
        stateVariables: menuStates.expense,
        click: createClickHandler('expense'),
        visibility: 'self',
        keepStaticOrder: true,
      },
      {
        id: 'holiday',
        label: 'Holiday',
        icon: 'iconsHolidaySideMenu',
        link: '/holiday',
        stateVariables: menuStates.holiday,
        click: createClickHandler('holiday'),
        visibility: 'self',
        keepStaticOrder: true,

        subItems: [
          {
            id: 'holidayPlanning',
            label: 'Planning',
            link: '/holiday/planning',
            parentId: 'holiday',
            visibility: 'self',
          },
          {
            id: 'holidayAnalysis',
            label: 'Analysis',
            link: '/holiday/analysis',
            parentId: 'holiday',
            visibility: 'self',
          },
        ],
      },

      {
        id: 'enquiry',
        label: 'Enquiry',
        icon: 'iconEnquiry',
        link: '/enquiry',
        stateVariables: menuStates.enquiry,
        click: createClickHandler('enquiry'),
        visibility: 'self',
        keepStaticOrder: true,

        subItems: [
          {
            id: 'leaveEnquiry',
            label: 'Leave',
            link: '/enquiry/leave',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'overtimeEnquiry',
            label: 'Over Time',
            link: '/enquiry/overtime',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'expenseEnquiry',
            label: 'Expense',
            link: '/enquiry/expense',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'loanEnquiry',
            label: 'Loan',
            link: '/enquiry/loan',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'travelEnquiry',
            label: 'Travel',
            link: '/enquiry/travel',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'wfhEnquiry',
            label: 'WFH',
            link: '/enquiry/wfh',
            parentId: 'enquiry',
            visibility: 'self',
          },
          {
            id: 'compOffEnquiry',
            label: 'Comp Off',
            link: '/enquiry/comp-off',
            parentId: 'enquiry',
            visibility: 'self',
          },
        ],
      },
      {
        id: 'admin',
        label: 'Admin',
        icon: 'iconsAdminSideMenu',
        link: '/admin',
        stateVariables: menuStates.admin,
        visibility: 'self',
        keepStaticOrder: true,
        click: createClickHandler('admin'),
        subItems: [
          {
            id: 'userList',
            label: 'All Users',
            link: '/admin/users',
            parentId: 'admin',
            visibility: 'self',
          },
          {
            id: 'roleList',
            label: 'All Roles',
            link: '/admin/roles',
            parentId: 'admin',
            visibility: 'self',
          },
          {
            id: 'reassignApprovals',
            label: 'Reassign Approvals',
            link: '/admin/reassign-approvals',
            parentId: 'admin',
            visibility: 'self',
          },
          {
            id: 'applicationServices',
            label: 'Application Services',
            link: '/admin/application-services',
            parentId: 'admin',
            visibility: 'self',
          },
          {
            id: 'encryptPassword',
            label: 'Encrypt Password',
            link: '/admin/encrypt-password',
            parentId: 'admin',
            visibility: 'self',
          },
        ],
      },
      {
        id: 'bonus',
        label: 'Bonus',
        icon: 'iconsBonusSideMenu',
        link: '/bonus',
        stateVariables: menuStates.bonus,
        click: createClickHandler('bonus'),
        visibility: 'self',
        keepStaticOrder: true,
      },
      {
        id: 'performance',
        label: 'Performance',
        icon: 'iconPerformance',
        link: '/performance',
        stateVariables: menuStates.performance,
        click: createClickHandler('performance'),
        visibility: 'self',
        keepStaticOrder: true,
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'iconsTicketSideMenu',
        link: '/tickets',
        stateVariables: menuStates.ticket,
        click: createClickHandler('ticket'),
        visibility: 'self',
        keepStaticOrder: true,
      },
      {
        id: 'calibration',
        label: 'Calibration',
        icon: 'iconCalibrationSideMenu',
        link: '/hr/calibration',
        stateVariables: menuStates.calibration,
        click: createClickHandler('calibration'),
        visibility: 'hr',
      },
      {
        id: 'travel',
        label: 'Travel Request',
        icon: 'iconsTravelRequestSideMenu',
        link: '/hr/travel-request',
        stateVariables: menuStates.travel,
        click: createClickHandler('travel'),
        visibility: 'hr',
        subItems: [
          {
            id: 'hrProcessRequest',
            label: 'Process Request',
            link: '/hr/booking-responsible',
            parentId: 'travel',
            visibility: 'hr',
          },
          {
            id: 'hrTravelEnquiry',
            label: 'Travel Enquiry',
            link: '/hr/travel-enquiry',
            parentId: 'travel',
            visibility: 'hr',
          },
          {
            id: 'hrRiskCountries',
            label: 'Risk Country',
            link: '/hr/risk-country',
            parentId: 'travel',
            visibility: 'hr',
          },
        ],
      },
      {
        id: 'hrExpense',
        label: 'Expense Claim',
        icon: 'iconsExpenseClaimsSideMenu',
        link: '/hr/expense-claims',
        stateVariables: menuStates.hrExpense,
        click: createClickHandler('hrExpense'),
        visibility: 'hr',
        subItems: [
          {
            id: 'hrProcessClaims',
            label: 'Process Claim',
            link: '/hr/expense/process-search',
            parentId: 'hrExpense',
            visibility: 'hr',
          },
          {
            id: 'hrClaimEnquiry',
            label: 'Claim Enquiry',
            link: '/hr/expense/enquiry',
            parentId: 'hrExpense',
            visibility: 'hr',
          },
        ],
      },
      {
        id: 'tickets',
        label: 'Tickets',
        icon: 'iconsTicketSideMenu',
        link: '/hr/tickets',
        stateVariables: menuStates.ticket,
        click: createClickHandler('ticket'),
        visibility: 'hr',
      },
      {
        id: 'employeePerformance',
        label: 'Employee Performance',
        icon: 'imagesSvgCryptoIconsGps',
        link: '/hr/employee-performance',
        stateVariables: menuStates.employeePerformance,
        click: createClickHandler('employeePerformance'),
        visibility: 'hr',
      },
      {
        id: 'employeeMaster',
        label: 'Employee',
        icon: 'iconEmployeeSideMenu',
        link: '/hr/employee-master',
        stateVariables: menuStates.employeeMaster,
        click: createClickHandler('employeeMaster'),
        visibility: 'hr',
      },
      {
        id: 'faq',
        label: 'FAQ',
        icon: 'iconFaq',
        link: '/faq',
        stateVariables: menuStates.faq,
        click: createClickHandler('faq'),
        visibility: 'self',
        keepStaticOrder: true,
      },
    ],
    [menuStates, createClickHandler],
  );

  // Filter based on viewMode
  const filteredByViewMode = useMemo(
    () =>
      menuItems
        .filter(
          menu => menu.visibility === 'both' || menu.visibility === viewMode,
        )
        .map(menu => ({
          ...menu,
          subItems: menu.subItems?.filter(
            sub => sub.visibility === 'both' || sub.visibility === viewMode,
          ),
        })),
    [menuItems, viewMode],
  );

  const menuFiltered = useMenu({ statisMenus: filteredByViewMode });

  return useMemo(() => {
    const filteredMenus = menuFiltered || [];

    // Ensure dashboard is always present for self-service view
    if (
      viewMode === 'self' &&
      !filteredMenus.find(menu => menu.link === '/dashboard')
    ) {
      filteredMenus.unshift({
        id: 'dashboard',
        label: 'Dashboard',
        icon: 'iconsDashboardSideMenu',
        link: '/dashboard',
        stateVariables: menuStates.dashboard,
        click: createClickHandler('dashboard'),
        visibility: 'self',
      });
    } else if (
      viewMode === 'hr' &&
      !filteredMenus.find(menu => menu.link === '/hr/dashboard')
    ) {
      filteredMenus.unshift({
        id: 'hrDashboard',
        label: 'Dashboard',
        icon: 'iconsDashboardSideMenu',
        link: '/hr/dashboard',
        stateVariables: menuStates.hrDashboard,
        click: createClickHandler('hrDashboard'),
        visibility: 'hr',
      });
    }

    return filteredMenus;
  }, [createClickHandler, menuFiltered, menuStates.dashboard, viewMode]);
};

export default useNavdata;
